import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    accessUrl: string;
}

export async function grantAccessToDataSources(dataSourceId: number) {
    const requestBody = { data_source: dataSourceId.toString(), no_redirect: true };

    try {
        const { data } = await axios.post<IResponse>(Endpoints.User.GrantDataSourceAccess, requestBody);

        return data.accessUrl;
    } catch (error) {
        return '';
    }
}
